<template>
  <div
    class="modal fade dq-modal"
    id="payroll_close_period_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-body dq-close-period-body">
          <div class="dq-close-period-hero">
            <span class="dq-close-period-badge">
              <i class="ti ti-lock"></i>
            </span>
          </div>

          <h4 class="mb-2 dq-close-period-title">Close payroll period</h4>
          <p class="mb-0 dq-close-period-subtitle">
            Close payroll for <b>{{ periodLabel }}</b>?
          </p>
          <p class="text-muted small mt-2 mb-0">
            After closing, you should not run or change payroll for this month unless your process
            explicitly allows reopening. Close only after the final run is approved.
          </p>

          <div class="dq-close-period-note mt-3">
            <i class="ti ti-alert-triangle me-2"></i>
            This locks the calendar month for payroll processing in DoneQuick HR.
          </div>

          <div class="d-flex justify-content-center flex-wrap gap-2 mt-4">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="submitting">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="submitting"
              @click="confirm"
            >
              <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
              Yes, close period
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { Modal } from "bootstrap";

const emit = defineEmits(["confirmed"]);

const submitting = ref(false);
const periodCode = ref("");

const periodLabel = computed(() => periodCode.value || "this month");

let modalInstance = null;

function getModal() {
  const el = document.getElementById("payroll_close_period_modal");
  if (!el) return null;
  modalInstance = Modal.getOrCreateInstance(el, { backdrop: false, keyboard: true });
  return modalInstance;
}

/** @param {string} yyyyMm e.g. 2026-01 */
function open(yyyyMm) {
  if (!yyyyMm || !/^\d{4}-\d{2}$/.test(yyyyMm)) return;
  periodCode.value = yyyyMm;
  submitting.value = false;
  getModal()?.show();
}

function hide() {
  modalInstance?.hide();
}

function confirm() {
  if (submitting.value || !periodCode.value) return;
  emit("confirmed", { period: periodCode.value });
}

function setSubmitting(value) {
  submitting.value = !!value;
}

defineExpose({ open, hide, setSubmitting });
</script>

<style scoped>
.dq-close-period-body {
  padding: 22px 20px 20px;
  text-align: center;
}
.dq-close-period-hero {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.dq-close-period-badge {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  background: rgba(100, 116, 139, 0.14);
  color: rgb(51, 65, 85);
}
.dq-close-period-title {
  font-weight: 800;
  letter-spacing: -0.02em;
}
.dq-close-period-subtitle {
  color: rgba(17, 24, 39, 0.68);
  font-size: 0.92rem;
  line-height: 1.45;
}
.dq-close-period-note {
  text-align: left;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.14);
  color: rgba(120, 53, 15, 0.95);
  font-size: 0.84rem;
  line-height: 1.4;
}
</style>
